module.exports = __webpack_public_path__ + "img/4.d5635e85.png";